import { queryOptions, useQuery } from '@tanstack/react-query';
import type { DefaultApiParams } from '@/std/pagination/types';
import {
    EmpresaConfigSeparacaoAutomaticaSistemasSchema,
    type ApiEmpresaConfiguracao,
} from '@/features/empresa/types/ApiEmpresaConfiguracao';
import { useLoginStore } from '@/features/login/store';
import { newRequest } from '@/std/api/newRequest';

type ApiEmpresaConfiguracaoGetParams = DefaultApiParams;

export const API_EMPRESA_CONFIGURACAO_GET_KEY = 'apiEmpresaConfiguracaoGet';

async function apiEmpresaConfiguracaoGet(
    params?: ApiEmpresaConfiguracaoGetParams,
): Promise<ApiEmpresaConfiguracao> {
    const configuracoes = await newRequest<ApiEmpresaConfiguracao[]>({
        params,
        type: 'get',
        url: 'Empresa/Configuracao',
    });

    const empresaConfig = configuracoes[0];

    if (!empresaConfig) {
        throw new Error('Nenhuma configuração da empresa foi encontrada');
    }

    return {
        ...empresaConfig,
        // Esse campo vem como string do backend, mas o frontend espera um array de objetos. Por isso, é necessário fazer o parse do JSON.
        emc_separacao_automatica_sistemas: EmpresaConfigSeparacaoAutomaticaSistemasSchema.parse(
            empresaConfig.emc_separacao_automatica_sistemas,
        ),
    };
}

export function apiEmpresaConfiguracaoGetQueryOptions(params?: ApiEmpresaConfiguracaoGetParams) {
    return queryOptions({
        queryFn: () => apiEmpresaConfiguracaoGet(params),
        queryKey: [API_EMPRESA_CONFIGURACAO_GET_KEY, params],
    });
}

export function useEmpresaConfiguracaoQuery(): {
    empresaConfig: ApiEmpresaConfiguracao | undefined;
    error: Error | null;
    isFetching: boolean;
} {
    const empresaIdpk = useLoginStore((s) => s.empresaIdpk);

    const { data, error, isFetching } = useQuery({
        ...apiEmpresaConfiguracaoGetQueryOptions(),
        enabled: empresaIdpk != null,
    });

    return {
        empresaConfig: data,
        error,
        isFetching,
    };
}
